export default __webpack_public_path__ + "static/media/title.be77da3c.svg";